import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    console.error("ErrorBoundary caught an error", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Card className="border-red-200 bg-red-50/50 my-4 shadow-sm">
          <CardHeader className="pb-3 border-b border-red-100">
            <CardTitle className="text-red-700 text-lg flex items-center gap-2">
              <span className="bg-red-100 text-red-600 p-1.5 rounded-md">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
              </span>
              Something went wrong
            </CardTitle>
          </CardHeader>
          <CardContent className="pt-4">
            <div className="text-sm text-red-900 mb-4 bg-white/60 p-3 rounded border border-red-100 font-mono overflow-auto max-h-[200px]">
              {this.state.error && this.state.error.toString()}
            </div>
            
            <Button 
              variant="outline" 
              className="border-red-200 text-red-700 hover:bg-red-100"
              onClick={() => this.setState({ hasError: false })}
            >
              Try Again
            </Button>
          </CardContent>
        </Card>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
